<section class="profile-view">
  <div class="profile-view-row mt-2 px-3 row">
    <div class="profile-view-element col-3">
      <div class="profile-view-title">
        Full Name
      </div>
      <div class="profile-view-text">
        {{ user?.fullname }}
      </div>
    </div>
    <div class="profile-view-element col-3">
      <div class="profile-view-title">
        Phone #
      </div>
      <div class="profile-view-text">
        {{ user?.phone_number }}
      </div>
    </div>
    <div class="profile-view-element col-3">
      <div class="profile-view-title">
        Email
      </div>
      <div class="profile-view-text">
        {{ user?.email }}
      </div>
    </div>
    <div class="profile-view-element col-3">
      <div class="profile-view-title">
        Username
      </div>
      <div class="profile-view-text">
        {{ user?.username }}
      </div>
    </div>
  </div>
  @if (user?.country || user?.state || user?.city) {
    <div class="profile-view-row mt-2 d-flex align-items-center flex-wrap">
      <div class="profile-view-element col-3">
        <div class="profile-view-title">
          Country, State, City
        </div>
        <div class="profile-view-text">
          @if (user?.country) {
            {{ user?.country }}
          }
          @if (user?.state) {
            ,{{ user?.state }}
          }
          @if (user?.city) {
            ,{{ user?.city }}
          }
        </div>
      </div>
    </div>
  }
  @if (user?.bio) {
    <div class="profile-view-row mt-2 d-flex align-items-center flex-wrap mb-2">
      <div class="profile-view-element col-12">
        <div class="profile-view-title">
          Bio
        </div>
        <div class="profile-view-text">
          {{ user?.bio }}
        </div>
      </div>
    </div>
  }
</section>
